/* TANARAS PDP CONFIGURATOR — JS v3 (Price Engine) */
(function() {
  'use strict';
  const COLORS = [
    {id:'schwarz',name:'Tiefes Schwarz',cat:'unicolor1',swatch:'#1a1210',bg:'#e8e4e2',g1:'#2a1a10',g2:'#1a1210',variant:'Tiefes Schwarz'},
    {id:'dunkelbraun',name:'Dunkles Braun',cat:'unicolor1',swatch:'#3a2418',bg:'#ede6e2',g1:'#5a3820',g2:'#2a1810',variant:'Dunkles Braun wie Kaffee'},
    {id:'mittelbraun',name:'Mittleres Braun',cat:'unicolor1',swatch:'#6b4a30',bg:'#f0e8e2',g1:'#8a6040',g2:'#4a3020',variant:'Mittleres Braun wie Schokolade'},
    {id:'hellbraun_k',name:'Hellbraun kühl',cat:'unicolor1',swatch:'#b8a898',bg:'#f2eeea',g1:'#c8b8a8',g2:'#8a7868',variant:'Hellbraun mit kühlem Unterton'},
    {id:'hellbraun_w',name:'Hellbraun warm',cat:'unicolor1',swatch:'#c8a878',bg:'#f5ede5',g1:'#d8b888',g2:'#9a7848',variant:'Hellbraun mit goldigem Unterton'},
    {id:'dunkelblond_k',name:'Dunkelblond kühl',cat:'unicolor1',swatch:'#c8c0a0',bg:'#f2f0e8',g1:'#d8d0b0',g2:'#a0987a',variant:'Dunkelblond mit kühlem Unterton'},
    {id:'dunkelblond_w',name:'Dunkelblond warm',cat:'unicolor1',swatch:'#d8c890',bg:'#f8f2e5',g1:'#e8d8a0',g2:'#b0a060',variant:'Dunkelblond mit warmem Unterton'},
    {id:'kupfer',name:'Kupferblond',cat:'unicolor1',swatch:'#e8c898',bg:'#f8f0e8',g1:'#e8c080',g2:'#c09050',variant:'Strahlendes Kupferblond'},
    {id:'mahagoni',name:'Mahagoni',cat:'unicolor1',swatch:'#c87060',bg:'#f5ece8',g1:'#d88070',g2:'#a05040',variant:'Mahagoni - kühles Rot'},
    {id:'hellblond',name:'Hellblond',cat:'unicolor1',swatch:'#f0e8d8',bg:'#fafaf6',g1:'#f0e8d8',g2:'#d0c8b0',variant:'Hellblond - Strahlend hell und kühl'},
    {id:'champagner',name:'Champagner',cat:'unicolor1',swatch:'#e8e0d0',bg:'#f8f4ef',g1:'#f0e8d8',g2:'#d0c0a0',variant:'Champagner - Strahlend hell und warm'},
    {id:'bali',name:'Bali',cat:'gestraehnt',swatch:'linear-gradient(135deg,#b08050,#d4b882)',bg:'#f5ede5',g1:'#d4b882',g2:'#8a6040',variant:'Bali - Warmes Braun küsst dunkles Blond'},
    {id:'santorini',name:'Santorini',cat:'gestraehnt',swatch:'linear-gradient(135deg,#a09080,#c8b8a0)',bg:'#f0ece8',g1:'#c8b8a0',g2:'#807068',variant:'Santorini  - Kühler Braunblond Mix aus 3 Farben'},
    {id:'ibiza',name:'Ibiza',cat:'gestraehnt',swatch:'linear-gradient(135deg,#d8c870,#e8e0c0)',bg:'#f8f5e8',g1:'#e8e0c0',g2:'#b0a060',variant:'Ibiza - Mittelblond trifft Platin'},
    {id:'hawaii',name:'Hawaii',cat:'gestraehnt',swatch:'linear-gradient(135deg,#d8c8a0,#e8dcc0)',bg:'#f8f4ec',g1:'#e8dcc0',g2:'#c0a878',variant:'Hawaii - Babylights in Sandblond'},
    {id:'vienna',name:'Vienna',cat:'balayage',swatch:'linear-gradient(135deg,#d4b882,#8a6040)',bg:'#f5ede9',g1:'#d4b882',g2:'#8a6040',variant:'Vienna - Ombre - Dunkelblond auf Sandblond'},
    {id:'losangeles',name:'Los Angeles',cat:'balayage',swatch:'linear-gradient(135deg,#d4d0cc,#9a9898)',bg:'#f0efee',g1:'#d4d0cc',g2:'#7a7878',variant:'Los Angeles- Ombre - Aschbraun zu Platin'},
    {id:'seoul',name:'Seoul',cat:'balayage',swatch:'linear-gradient(135deg,#d4b060,#a07840)',bg:'#fdf5e8',g1:'#d4b060',g2:'#8a6030',variant:'Seoul - Balayage - warmes Blond auf Braun'},
    {id:'singapur',name:'Singapur',cat:'balayage',swatch:'linear-gradient(135deg,#c0a888,#806848)',bg:'#f2ece5',g1:'#c0a888',g2:'#706040',variant:'Singapur - Balayage - Braun auf kühles Mittelblond'},
    {id:'hongkong',name:'Hong Kong',cat:'balayage',swatch:'linear-gradient(135deg,#c8b8a0,#8a7860)',bg:'#f2ede8',g1:'#c8b8a0',g2:'#7a6850',variant:'Hong Kong - Balayage - Braun auf Platinbraun Mix'},
    {id:'barcelona',name:'Barcelona',cat:'balayage',swatch:'linear-gradient(135deg,#c0a078,#8a6848)',bg:'#f5ede5',g1:'#c0a078',g2:'#7a5838',variant:'Barcelona - Balayage - Braun mit Blondbraun Mix'},
    {id:'istanbul',name:'Istanbul',cat:'balayage',swatch:'linear-gradient(135deg,#a08070,#6a4a38)',bg:'#f5f0ed',g1:'#a08070',g2:'#5a3a28',variant:'Istanbul - Balayage - Fließende Brauntöne'},
    {id:'athens',name:'Athens',cat:'balayage',swatch:'linear-gradient(135deg,#b0a898,#7a7068)',bg:'#f0ece8',g1:'#b0a898',g2:'#6a6058',variant:'Athens - Balayage - Braun auf Aschmix'},
    {id:'lasvegas',name:'Las Vegas',cat:'balayage',swatch:'linear-gradient(135deg,#d0b070,#9a7840)',bg:'#f8f0e5',g1:'#d0b070',g2:'#8a6830',variant:'Las Vegas - Balayage - Braun auf Goldmix'},
    {id:'dubai',name:'Dubai',cat:'balayage',swatch:'linear-gradient(135deg,#9a8878,#5a4838)',bg:'#f0ece8',g1:'#9a8878',g2:'#4a3828',variant:'Dubai - Balayage - Dunkelbraun Aschmix'},
    {id:'amsterdam',name:'Amsterdam',cat:'balayage',swatch:'linear-gradient(135deg,#c8b890,#8a7858)',bg:'#f5f0e8',g1:'#c8b890',g2:'#7a6848',variant:'Amsterdam - Balayage - Mittelblond zu Nussblond'},
    {id:'sydney',name:'Sydney',cat:'balayage',swatch:'linear-gradient(135deg,#c0c8d0,#7a8890)',bg:'#f0f2f5',g1:'#c0c8d0',g2:'#6a7880',variant:'Sydney - Balayage - Braun auf eisiges Blond'},
  ];

  const TOOLS_PRICE = 100;
  let state = { step:1, hairtype:null, color:null, length:'45', amount:'extension', bundle:'set', extra:0 };
  let productData = {};
  try { productData = JSON.parse(document.getElementById('tanaras-product-data').textContent); } catch(e) { console.error('TC: parse error', e); }

  function $(id) { return document.getElementById(id); }
  function toggleClass(id, cls, force) { const el = $(id); if (el) el.classList.toggle(cls, force); }
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function getProductName() { return state.hairtype === 'fine' ? 'THINVISIS' : 'INVISIS'; }
  function getColorObj() { return COLORS.find(c => c.id === state.color); }
  function formatPrice(p) { return p ? Math.round(p) + ' €' : '—'; }
  function gramPerUnit() { return state.length === '55' ? 60 : 50; }

  /* ─── VARIANT FINDERS ─── */
  function findSetVariant(cv, len, amt) {
    const t = state.hairtype === 'fine' ? 'thinvisis' : 'invisis';
    const vs = productData[`${t}_set_${len}`]; if (!vs) return null;
    const cn = norm(cv), kw = amt === 'extension' ? 'Haarverlängerung' : 'Haarverdichtung';
    return vs.find(v => norm(v.option1) === cn && v.option2 && v.option2.includes(kw));
  }
  function findJustVariant(cv, len) {
    const t = state.hairtype === 'fine' ? 'thinvisis' : 'invisis';
    const vs = productData[`just_${t}`]; if (!vs) return null;
    const cn = norm(cv);
    return vs.find(v => norm(v.option1) === cn && v.option2 && v.option2.startsWith(len + ' cm'));
  }

  /* ═══════════════════════════════════════════
     PRICE ENGINE — Unit-based pricing
     1 unit = 50g (35/45cm) or 60g (55cm)
     ═══════════════════════════════════════════ */
  function getTotalUnits() {
    const baseUnits = state.amount === 'extension' ? 2 : 1;
    const extraUnits = state.extra === 0 ? 0 : (state.extra === 50 ? 1 : 2);
    return baseUnits + extraUnits;
  }

  function calculatePricing() {
    const c = getColorObj();
    if (!c) return null;
    const totalUnits = getTotalUnits();
    const g = gramPerUnit();
    const totalGrams = totalUnits * g;

    const justV = findJustVariant(c.variant, state.length);
    if (!justV) return null;
    const justUnitPrice = justV.price / 100;

    const setVerdichtung = findSetVariant(c.variant, state.length, 'thickening');
    const setVerlaengerung = findSetVariant(c.variant, state.length, 'extension');
    const setVPrice = setVerdichtung ? setVerdichtung.price / 100 : null;
    const setEPrice = setVerlaengerung ? setVerlaengerung.price / 100 : null;

    /* SET OPTION */
    let setPrice, setCartItems = [], setDescription;
    if (totalUnits <= 1) {
      setPrice = setVPrice;
      setCartItems = [{ variantId: setVerdichtung?.id, qty: 1, label: 'SET Verdichtung' }];
      setDescription = `SET Verdichtung (${g}g)`;
    } else if (totalUnits === 2) {
      setPrice = setEPrice;
      setCartItems = [{ variantId: setVerlaengerung?.id, qty: 1, label: 'SET Verlängerung' }];
      setDescription = `SET Verlängerung (${2*g}g)`;
    } else {
      const overflow = totalUnits - 2;
      setPrice = setEPrice + overflow * justUnitPrice;
      setCartItems = [
        { variantId: setVerlaengerung?.id, qty: 1, label: 'SET Verlängerung' },
        { variantId: justV.id, qty: overflow, label: `${overflow}x JUST (${overflow * g}g)` }
      ];
      setDescription = `SET Verlängerung (${2*g}g) + ${overflow}x JUST (${overflow * g}g)`;
    }
    const setStrikePrice = totalUnits * justUnitPrice + TOOLS_PRICE;
    const setSaving = setStrikePrice - setPrice;

    /* JUST OPTION */
    const justPrice = totalUnits * justUnitPrice;
    const justCartItems = [{ variantId: justV.id, qty: totalUnits, label: `${totalUnits}x JUST (${totalGrams}g)` }];
    const justDescription = `${totalUnits}x JUST je ${formatPrice(justUnitPrice)}`;

    return {
      totalUnits, totalGrams,
      justUnitPrice,
      setOption: { price: setPrice, strikePrice: setStrikePrice, saving: setSaving, cartItems: setCartItems, description: setDescription },
      justOption: { price: justPrice, cartItems: justCartItems, description: justDescription }
    };
  }

  function getActivePrice() {
    const p = calculatePricing();
    if (!p) return null;
    return state.bundle === 'set' ? p.setOption.price : p.justOption.price;
  }

  /* ─── DISPLAY PRICE (step-aware: lowest entry point for early steps) ─── */
  function getDisplayPrice() {
    const c = getColorObj();

    /* Step 1: no color yet → cheapest SET price (35cm Verdichtung, cheapest color group) */
    if (state.step <= 1 || !c) {
      const sets35 = productData.invisis_set_35 || productData.thinvisis_set_35 || [];
      const verdichtung = sets35.filter(v => v.option2 && v.option2.includes('Haarverdichtung'));
      if (verdichtung.length) {
        const cheapest = Math.min(...verdichtung.map(v => v.price));
        return { price: cheapest / 100, prefix: 'ab ' };
      }
      return { price: 175, prefix: 'ab ' };
    }

    /* Step 2: color selected → cheapest JUST for that color (35cm, 1 unit) */
    if (state.step === 2) {
      const just35 = findJustVariant(c.variant, '35');
      if (just35) return { price: just35.price / 100, prefix: 'ab ' };
      return { price: null, prefix: 'ab ' };
    }

    /* Step 3: color + length → cheapest JUST for that color + length (1 unit) */
    if (state.step === 3) {
      const justV = findJustVariant(c.variant, state.length);
      if (justV) return { price: justV.price / 100, prefix: 'ab ' };
      return { price: null, prefix: 'ab ' };
    }

    /* Step 4+: actual configured price */
    return { price: getActivePrice(), prefix: '' };
  }

  /* ─── COLOR IMAGES (fallback from variants) ─── */
  let colorImages = {};
  function buildColorImages() {
    (productData.invisis_set_45 || []).forEach(v => {
      const s = v.featured_image?.src || v.image;
      if (s && v.option1) colorImages[norm(v.option1)] = s.startsWith('//') ? 'https:' + s : s;
    });
  }
  function getColorImage(vn) { return colorImages[norm(vn)] || null; }

  /* ─── KONFIG HERO IMAGES (step-aware, per color) ─── */
  const KONFIG_CDN = 'https://cdn.shopify.com/s/files/1/0728/1429/7411/files/';
  const KONFIG_SLUGS = {
    schwarz: 'tiefes-schwarz',
    dunkelbraun: 'dunkles-braun',
    mittelbraun: 'mittleres-braun',
    hellbraun_k: 'hellbraun-kuehl',
    hellbraun_w: 'hellbraun-warm',
    dunkelblond_k: 'dunkelblond-kuehl',
    dunkelblond_w: 'dunkelblond-warm',
    kupfer: 'kupferblond',
    mahagoni: 'mahagoni',
    hellblond: 'hellblond',
    champagner: 'champagner',
    bali: 'bali',
    santorini: 'santorini',
    ibiza: 'ibiza',
    hawaii: 'hawaii',
    vienna: 'vienna',
    losangeles: 'los-angeles',
    seoul: 'seoul',
    singapur: 'singapur',
    hongkong: 'hong-kong',
    barcelona: 'barcelona',
    istanbul: 'istanbul',
    athens: 'athens',
    lasvegas: 'las-vegas',
    dubai: 'dubai',
    amsterdam: 'amsterdam',
    sydney: 'sydney',
  };
  function kImg(name) { return KONFIG_CDN + 'konfig-' + name + '.webp'; }

  /* Preload all images for a color */
  let preloadedColors = {};
  function preloadColorImages(slug) {
    if (!slug || preloadedColors[slug]) return;
    preloadedColors[slug] = true;
    const urls = [
      slug + '-swatch', slug + '-laengen',
      slug + '-1u', slug + '-2u', slug + '-3u', slug + '-4u',
      slug + '-set', slug + '-set-1j', slug + '-set-2j'
    ];
    urls.forEach(u => { const img = new Image(); img.src = kImg(u); });
  }

  function getHeroImage() {
    const c = getColorObj();
    const slug = c ? KONFIG_SLUGS[c.id] : null;

    if (!slug) {
      if (state.step === 1 || !c) return kImg('start');
      return getColorImage(c.variant);
    }

    if (state.step <= 1) return kImg('start');
    if (state.step === 2) return kImg(slug + '-swatch');
    if (state.step === 3) return kImg(slug + '-laengen');

    const totalUnits = getTotalUnits();
    if (state.step === 4) return kImg(slug + '-' + totalUnits + 'u');

    if (state.step >= 5) {
      if (state.bundle === 'just') return kImg(slug + '-' + totalUnits + 'u');
      const overflow = totalUnits > 2 ? totalUnits - 2 : 0;
      if (overflow === 0) return kImg(slug + '-set');
      return kImg(slug + '-set-' + overflow + 'j');
    }

    return kImg(slug + '-swatch');
  }

  /* ─── PROGRESS ─── */
  function updateProgress() {
    for (let i = 1; i <= 5; i++) {
      const c = $('tc-prog'+i), l = $('tc-slbl'+i);
      if (c) { c.classList.remove('done','active'); if (i < state.step) c.classList.add('done'); else if (i === state.step) c.classList.add('active'); }
      if (l) { l.classList.remove('done','active'); if (i < state.step) l.classList.add('done'); else if (i === state.step) l.classList.add('active'); }
    }
    for (let i = 1; i <= 4; i++) { const ln = $('tc-line'+i); if (ln) ln.classList.toggle('done', i < state.step); }
  }
  window.tcClickProgress = function(step) { if (step < state.step) showStep(step); };

  /* ─── HERO (with fade transition) ─── */
  let currentHeroSrc = '';
  function updateHero() {
    const c = getColorObj(); const bg = c ? c.bg : '#f5ede9';
    const hero = $('tc-hero'); if (hero) hero.style.background = bg;
    const heroImg = $('tc-heroImg'), cssHair = $('tc-cssHairDisplay');
    const img = getHeroImage();

    if (heroImg && img) {
      if (img !== currentHeroSrc) {
        heroImg.style.opacity = '0';
        currentHeroSrc = img;
        setTimeout(() => {
          const onReady = () => { heroImg.style.opacity = '1'; };
          heroImg.onerror = () => {
            const c = getColorObj();
            const fallback = c ? getColorImage(c.variant) : null;
            if (fallback) { heroImg.src = fallback; heroImg.onload = onReady; }
            else onReady();
          };
          if (heroImg.complete && heroImg.src === img) {
            onReady();
          } else {
            heroImg.onload = onReady;
          }
          heroImg.src = img;
        }, 180);
      }
      heroImg.style.display = 'block';
      if (cssHair) cssHair.style.display = 'none';
    } else {
      if (heroImg) { heroImg.style.display = 'none'; heroImg.style.opacity = '1'; }
      if (cssHair) cssHair.style.display = 'flex';
      currentHeroSrc = '';
    }
    const badge = $('tc-heroBadge');
    if (badge) {
      const name = getProductName();
      if (state.step <= 1 && !state.hairtype) badge.textContent = 'INVISIS SET';
      else if (state.step < 5) badge.textContent = name;
      else badge.textContent = state.bundle === 'set' ? name + ' SET' : 'JUST ' + name;
    }
    const price = $('tc-heroPrice');
    if (price) {
      const dp = getDisplayPrice();
      price.textContent = dp.price ? dp.prefix + formatPrice(dp.price) : 'ab 175 €';
    }
  }

  /* ─── STICKY ─── */
  function updateSticky() {
    const dp = getDisplayPrice();
    const sp = $('tc-stickyPrice'); if (sp) sp.textContent = dp.price ? dp.prefix + formatPrice(dp.price) : 'ab 175 €';
    const c = getColorObj(); let d = '';
    if (state.step >= 1 && state.hairtype) d += getProductName();
    if (state.step >= 2 && c) d += ' · ' + c.name;
    if (state.step >= 3) d += ' · ' + state.length + ' cm';
    if (state.step >= 4) { const p = calculatePricing(); if (p) d += ' · ' + p.totalGrams + 'g'; }
    const sd = $('tc-stickyDetail'); if (sd) sd.textContent = d || 'Konfiguriere dein Produkt';
    const btn = $('tc-stickyBtn'); if (!btn) return;
    if (state.step <= 5) { btn.textContent = 'Weiter'; btn.disabled = (state.step === 1 && !state.hairtype) || (state.step === 2 && !state.color); }
    else { btn.textContent = 'In den Warenkorb · ' + formatPrice(getActivePrice()); btn.disabled = false; }
  }

  /* ─── SUMMARY ─── */
  function updateSummary() {
    const name = getProductName();
    const bl = state.bundle === 'set' ? 'SET' : 'JUST';
    const sp = $('tc-sumProduct'); if (sp) sp.textContent = `${name} ${bl}`;
    const c = getColorObj();
    const sc = $('tc-sumColor'); if (sc) sc.textContent = c ? c.name : '—';
    const ss = $('tc-sumSwatch'); if (ss) ss.style.background = c ? c.swatch : 'var(--tc-border)';
    const sl = $('tc-sumLength'); if (sl) sl.textContent = state.length + ' cm';
    const p = calculatePricing();
    const sa = $('tc-sumAmount');
    if (sa && p) sa.textContent = p.totalGrams + 'g · ' + (state.amount === 'extension' ? 'Verlängerung' : 'Verdichtung') + (state.extra ? ' + Extra' : '');
    const sb = $('tc-sumBundle'); if (sb) sb.textContent = bl;
    const er = $('tc-sumExtraRow');
    if (er) {
      if (p && state.bundle === 'set' && p.setOption.cartItems.length > 1) {
        er.style.display = 'flex';
        const se = $('tc-sumExtra');
        const overflow = p.setOption.cartItems[1];
        if (se) se.textContent = overflow.label + ' · ' + formatPrice(overflow.qty * p.justUnitPrice);
      } else if (p && state.bundle === 'just' && p.totalUnits > 1) {
        er.style.display = 'flex';
        const se = $('tc-sumExtra');
        if (se) se.textContent = p.justOption.description;
      } else { er.style.display = 'none'; }
    }
    const st = $('tc-sumTotal'); if (st) st.textContent = formatPrice(getActivePrice());
  }

  /* ─── STEP 4 LABELS ─── */
  function updateAmountLabels() {
    const is55 = state.length === '55';
    const ed = $('tc-amtExtDetail'); if (ed) ed.textContent = is55 ? '8 Tressen · 120g' : '8 Tressen · 100g';
    const td = $('tc-amtThickDetail'); if (td) td.textContent = is55 ? '4 Tressen · 60g' : '4 Tressen · 50g';
  }

  /* ─── STEP 5 PRICE LABELS (the core change) ─── */
  function updatePriceLabels() {
    const p = calculatePricing();
    if (!p) return;

    const name = getProductName();

    /* SET card */
    const setEl = $('tc-sjSetPrice');
    const setStrikeEl = $('tc-sjSetStrike');
    const setSavingEl = $('tc-sjSetSaving');
    const setDescEl = $('tc-sjSetDesc');
    if (setEl) setEl.textContent = formatPrice(p.setOption.price);
    if (setStrikeEl) setStrikeEl.textContent = formatPrice(p.setOption.strikePrice);
    if (setSavingEl) setSavingEl.textContent = `Du sparst ${formatPrice(p.setSaving || p.setOption.saving)}`;
    if (setDescEl) setDescEl.textContent = p.setOption.description;

    /* SET title + sub */
    const setTitle = $('tc-sjSetTitle');
    if (setTitle) {
      if (p.totalUnits <= 1) setTitle.textContent = name + ' SET · Verdichtung';
      else if (p.totalUnits === 2) setTitle.textContent = name + ' SET · Verlängerung';
      else setTitle.textContent = name + ' SET + JUST ' + name;
    }

    /* JUST card */
    const justEl = $('tc-sjJustPrice');
    const justDescEl = $('tc-sjJustDesc');
    if (justEl) justEl.textContent = formatPrice(p.justOption.price);
    if (justDescEl) justDescEl.textContent = p.justOption.description;

    /* JUST title */
    const justTitle = $('tc-sjJustTitle');
    if (justTitle) justTitle.textContent = p.totalUnits === 1 ? 'JUST ' + name : p.totalUnits + 'x JUST ' + name;
  }

  /* ─── NAVIGATION ─── */
  function showStep(n) {
    state.step = n;
    document.querySelectorAll('.tc-step').forEach(s => s.classList.remove('active'));
    const stepEl = $('tc-step'+n); if (stepEl) stepEl.classList.add('active');
    toggleClass('tc-summary','show', n > 5);
    if (n === 4) {
      const es = $('tc-extraSection'); if (es) es.classList.add('show');
      const ed = $('tc-extraDivider'); if (ed) ed.style.display = 'block';
      updateAmountLabels(); updateExtraUI();
    }
    updateProgress(); updateHero(); updateSticky(); updatePriceLabels();
    if (n > 5) updateSummary();
    window.scrollTo({top:0,behavior:'smooth'});
  }

  window.tcNextStep = function() { if (state.step < 6) showStep(state.step + 1); };
  window.tcGoToStep = function(n) { showStep(n); };
  window.tcGoBack = function() { if (state.step > 1) showStep(state.step - 1); };
  window.tcStickyAction = function() {
    if (state.step <= 5) { if (state.step === 1 && !state.hairtype) return; if (state.step === 2 && !state.color) return; window.tcNextStep(); }
    else { window.tcAddToCart(); }
  };

  /* ─── STEP 1 ─── */
  window.tcSelectHairtype = function(type) {
    state.hairtype = type;
    toggleClass('tc-htNormal','selected', type === 'normal');
    toggleClass('tc-htFine','selected', type === 'fine');
    updateBundleLabels(); updateHero(); updateSticky();
    setTimeout(() => window.tcNextStep(), 300);
  };

  /* ─── STEP 2 ─── */
  let currentFilter = 'all';
  function renderColorGrid() {
    const grid = $('tc-colorGrid'); if (!grid) return; grid.innerHTML = '';
    const filtered = currentFilter === 'all' ? COLORS : COLORS.filter(c => c.cat === currentFilter);
    filtered.forEach(c => {
      const div = document.createElement('div');
      div.className = 'tc-color-swatch' + (state.color === c.id ? ' selected' : '');
      div.dataset.colorId = c.id;
      div.onclick = () => window.tcSelectColor(c.id);
      const imgUrl = getColorImage(c.variant);
      const inner = imgUrl
        ? `<div class="tc-color-swatch-inner tc-color-swatch-img"><img src="${imgUrl}" alt="${c.name}" loading="lazy"></div>`
        : `<div class="tc-color-swatch-inner" style="background:${c.swatch};"></div>`;
      div.innerHTML = `${inner}<div class="tc-color-swatch-bar"><div class="tc-color-swatch-name">${c.name}</div></div><div class="tc-check"><svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg></div>`;
      grid.appendChild(div);
    });
  }
  function updateColorSelection() { document.querySelectorAll('.tc-color-swatch').forEach(el => { el.classList.toggle('selected', el.dataset.colorId === state.color); }); }
  window.tcFilterColors = function(cat, btn) {
    document.querySelectorAll('.tc-cf-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active'); currentFilter = cat; renderColorGrid();
  };
  window.tcSelectColor = function(id) {
    state.color = id; const c = getColorObj(); updateColorSelection();
    if (c && KONFIG_SLUGS[c.id]) preloadColorImages(KONFIG_SLUGS[c.id]);
    const detail = $('tc-colorDetail');
    if (c && detail) {
      detail.classList.add('show');
      const cn = $('tc-cdName'); if (cn) cn.textContent = c.name;
      const cd = $('tc-cdDesc'); if (cd) cd.textContent = c.variant;
      const cs = $('tc-cdSwatch');
      if (cs) { const iu = getColorImage(c.variant); if (iu) { cs.style.background='none'; cs.style.backgroundImage=`url(${iu})`; cs.style.backgroundSize='cover'; cs.style.backgroundPosition='center'; } else { cs.style.backgroundImage='none'; cs.style.background=c.swatch; } }
      const catLabels = {unicolor1:'Unicolor',gestraehnt:'Gesträhnt · Inseln',balayage:'Balayage · Städte'};
      const cc = $('tc-cdCat'); if (cc) cc.textContent = catLabels[c.cat] || c.cat;
    }
    const nb = $('tc-step2Next'); if (nb) nb.disabled = false;
    updateHero(); updateSticky();
  };

  /* ─── STEP 3 ─── */
  window.tcSelectLength = function(len) {
    state.length = len;
    ['35','45','55'].forEach(l => toggleClass('tc-len'+l,'selected', l === len));
    updateAmountLabels(); updateExtraUI(); updatePriceLabels(); updateHero(); updateSticky();
  };

  /* ─── STEP 4 ─── */
  window.tcSelectAmount = function(amt) {
    state.amount = amt; state.extra = 0;
    toggleClass('tc-amtExt','selected', amt === 'extension');
    toggleClass('tc-amtThick','selected', amt === 'thickening');
    const es = $('tc-extraSection'); if (es) es.classList.add('show');
    const ed = $('tc-extraDivider'); if (ed) ed.style.display = 'block';
    updateExtraUI(); updatePriceLabels(); updateHero(); updateSticky();
  };
  window.tcToggleExtra = function(grams) {
    state.extra = (state.extra === grams || grams === 0) ? 0 : grams;
    updateExtraUI(); updateHero(); updateSticky();
  };

  function updateExtraUI() {
    const name = getProductName();
    const is55 = state.length === '55';
    const smallAmt = is55 ? 60 : 50;
    const bigAmt = is55 ? 120 : 100;
    const epn = $('tc-extraProductName'); if (epn) epn.textContent = name;
    const a50 = $('tc-extra50Amt'); if (a50) a50.textContent = '+ ' + smallAmt + 'g';
    const a100 = $('tc-extra100Amt'); if (a100) a100.textContent = '+ ' + bigAmt + 'g';

    const c = getColorObj();
    if (c) {
      const justV = findJustVariant(c.variant, state.length);
      const unit = justV ? justV.price / 100 : null;
      const p50 = $('tc-extra50Price'); if (p50) p50.textContent = unit ? '+ ' + formatPrice(unit) : '—';
      const p100 = $('tc-extra100Price'); if (p100) p100.textContent = unit ? '+ ' + formatPrice(unit * 2) : '—';
    }
    toggleClass('tc-extra50','selected', state.extra === 50);
    toggleClass('tc-extra100','selected', state.extra === 100);
    const pill = $('tc-extraPill');
    if (pill) {
      pill.classList.toggle('show', state.extra > 0);
      const pt = $('tc-extraPillText');
      if (pt && state.extra) {
        const amt = state.extra === 50 ? smallAmt : bigAmt;
        const c2 = getColorObj();
        const justV = c2 ? findJustVariant(c2.variant, state.length) : null;
        const unitP = justV ? justV.price / 100 : 0;
        const extraP = state.extra === 50 ? unitP : unitP * 2;
        pt.innerHTML = `<strong>+ ${amt}g</strong> JUST ${name} wird mitbestellt · ${formatPrice(extraP)}`;
      }
    }
  }

  /* ─── STEP 5 ─── */
  window.tcSelectBundle = function(b) {
    state.bundle = b;
    toggleClass('tc-sjSet','selected', b === 'set');
    toggleClass('tc-sjJust','selected', b === 'just');
    updatePriceLabels(); updateHero(); updateSticky();
  };

  function updateBundleLabels() {
    const name = getProductName();
    const st = $('tc-sjSetTitle'); if (st) st.textContent = name + ' SET';
    const jt = $('tc-sjJustTitle'); if (jt) jt.textContent = 'JUST ' + name;
  }

  /* ─── MISC ─── */
  window.tcToggleInfo = function(id) { const el = $(id); if (el) el.classList.toggle('open'); };
  window.tcOpenWhatsApp = function(msg) { const num = document.querySelector('[data-wa-number]'); window.open('https://wa.me/' + (num ? num.dataset.waNumber : '4915252843474') + '?text=' + encodeURIComponent(msg), '_blank'); };

  /* ─── CART API (uses price engine) ─── */
  window.tcAddToCart = async function() {
    const p = calculatePricing();
    if (!p) { alert('Preis konnte nicht berechnet werden. Bitte kontaktiere uns per WhatsApp.'); return; }

    const cartPlan = state.bundle === 'set' ? p.setOption.cartItems : p.justOption.cartItems;
    const items = cartPlan.filter(i => i.variantId).map(i => ({ id: i.variantId, quantity: i.qty }));

    if (items.length === 0) { alert('Variante nicht gefunden. Bitte kontaktiere uns per WhatsApp.'); return; }

    const btn = $('tc-stickyBtn'); const ab = document.querySelector('.tc-summary .tc-btn-primary');
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
    if (ab) { ab.disabled = true; ab.textContent = 'Wird hinzugefügt…'; }
    try {
      const r = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items}) });
      if (!r.ok) throw new Error('Cart error');
      window.location.href = '/cart';
    } catch(e) {
      console.error(e); alert('Fehler. Bitte erneut versuchen.');
      if (btn) { btn.disabled=false; btn.textContent='In den Warenkorb'; }
      if (ab) { ab.disabled=false; ab.textContent='In den Warenkorb'; }
    }
  };

  /* ─── DESKTOP STICKY ALIGNMENT ─── */
  function positionDesktopSticky() {
    const sticky = $('tc-stickyBar');
    if (!sticky) return;
    if (window.innerWidth < 768) { sticky.removeAttribute('style'); return; }
    const ref = document.querySelector('.tc-stepper-wrap') || document.querySelector('.tc-step-container');
    if (!ref) return;
    const rect = ref.getBoundingClientRect();
    sticky.style.left = rect.left + 'px';
    sticky.style.width = rect.width + 'px';
    sticky.style.maxWidth = 'none';
    sticky.style.transform = 'none';
    sticky.style.right = 'auto';
    sticky.style.borderRadius = '16px 16px 0 0';
    sticky.style.padding = '14px 32px';
  }

  /* ─── INIT ─── */
  function init() {
    buildColorImages();
    document.querySelectorAll('.tc-cf-btn').forEach((b,i) => { b.dataset.filter = ['all','balayage','gestraehnt','unicolor1'][i] || 'all'; });
    renderColorGrid(); updateProgress(); updateSticky(); updateHero();
    (new Image()).src = kImg('start');
    positionDesktopSticky();
    window.addEventListener('resize', positionDesktopSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


